import moment from 'moment';
import { call, fork, put, select, take } from 'redux-saga/effects';
import { getJSON } from '../util';


export function* fetch(date, user) {
    const url = '/api/daily-number';
    let response;

    try {
        response = yield call(getJSON, url,
            { today: date, birth_date: user.birth_date || undefined },
            { cache: false }
        );
    } catch (e) {
        yield put({ type: 'number:update' });
        return;
    }

    yield put({ type: 'number:update', payload: response });
}

export function* watchLogins(date) {
    const user = yield select(state => state.user);
    if (user.logged_in) {
        yield fork(fetch, date, user);
    }
    while (true) {
        let action = yield take('user:logged-in');
        yield fork(fetch, date, action.payload);
    }
}

export function* watchLogouts() {
    const user = yield select(state => state.user);
    if (!user.logged_in) {
        yield put({type: 'number:update'});
    }
    while (true) {
        yield take('user:logged-out');
        yield put({type: 'number:update'});
    }
}

export function* root() {
    const action = yield take('number:required');
    const date = action.payload || moment().format('YYYY-MM-DD');

    yield fork(watchLogins, date);
    yield fork(watchLogouts);
}



// WEBPACK FOOTER //
// ./app/sagas/number.js